import { useRef } from "react";
import { motion } from "framer-motion";
import CustomButton from "../common/CustomBtn";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroVideo from "../../assets/landing-hero.mp4";
import heroFallback from "../../assets/hero-fallback.jpg";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
};

const HeroBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ref = useRef(null);

  return (
    <div
      className="relative w-full h-[90vh] sm:h-screen overflow-hidden"
      ref={ref}
    >
      <video
        muted
        playsInline
        autoPlay
        loop
        preload="auto"
        poster={heroFallback}
        className="absolute top-0 left-0 z-0 object-cover w-full h-full"
        webkit-playsinline="true"
      >
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="absolute inset-0 z-10 bg-black/50" />

      <div className="absolute inset-0 z-20 flex flex-col items-center justify-end px-6 pb-8 text-center text-white sm:pb-12 md:px-0 maxContainer">
        <motion.div
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
          variants={fadeInUp}
          className="bg-[#3636368a] max-w-max mb-2 rounded-lg px-5 py-2"
        >
          <p className="sm:font-medium text-[14px] capitalize text-secondary">
            {t("heroTranslate.subheading")}
          </p>
        </motion.div>

        <motion.h1
          initial="hidden"
          transition={{ delay: 0.4 }}
          animate="visible"
          variants={fadeInUp}
          className="sm:text-[32px] font-semibold md:leading-tight max-w-[925px] mb-5"
        >
          {t("heroTranslate.heading")}
        </motion.h1>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={{ delay: 0.8 }}
        >
          <CustomButton
            sx={{ py: 1, px: 3, fontSize: "14px" }}
            onClick={() => navigate("/el-parduotuve")}
          >
            {t("heroTranslate.button_text")}
          </CustomButton>
        </motion.div>
      </div>
    </div>
  );
};

export default HeroBanner;
